import { ERouteHttpVerb } from "@devowl-wp/api";
const routeLocationEntityMetDataGet = {
    path: "/metadata/entity",
    method: ERouteHttpVerb.GET
};
export { routeLocationEntityMetDataGet };
